import React, { useState, useEffect } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import './InterviewDetailsPage.css';

const InterviewDetailsPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [interview, setInterview] = useState(null);
  const [relatedInterviews, setRelatedInterviews] = useState([]);
  const [isLiked, setIsLiked] = useState(false);

  useEffect(() => {
    const sampleInterview = {
      id: parseInt(id),
      title: `حوار رقم ${id}`,
      interviewee: `الضيف ${Math.floor(Math.random() * 25) + 1}`,
      interviewer: `المحاور ${Math.floor(Math.random() * 5) + 1}`,
      type: ['مقابلة مكتوبة', 'مقابلة صوتية', 'مقابلة مرئية'][Math.floor(Math.random() * 3)],
      category: ['كاتب', 'شاعر', 'رسام', 'ناقد أدبي', 'مثقف'][Math.floor(Math.random() * 5)],
      summary: `ملخص للحوار رقم ${id} الذي يتناول مواضيع مهمة ومثيرة للاهتمام في عالم الأدب والثقافة`,
      publishDate: new Date(2024, Math.floor(Math.random() * 12), Math.floor(Math.random() * 28) + 1),
      duration: Math.floor(Math.random() * 60) + 15,
      views: Math.floor(Math.random() * 1000) + 100,
      likes: Math.floor(Math.random() * 50) + 10,
      tags: ['أدب', 'ثقافة', 'فن', 'شعر', 'كتابة'],
      intervieweeBio: `سيرة ذاتية مختصرة للضيف. شخصية مؤثرة في المجال الثقافي والأدبي، له إسهامات مهمة في تطوير الحركة الأدبية المعاصرة.`,
      content: `
        <div class="interview-content">
          <h3>المحاور: أهلاً وسهلاً بك في برنامجنا، حدثنا عن بداياتك في عالم الأدب؟</h3>
          <p><strong>الضيف:</strong> شكراً لكم على هذه الاستضافة الكريمة. بدايتي مع الأدب كانت منذ الصغر، حيث كنت أقرأ كثيراً وأحب الكتابة. تأثرت بالعديد من الكتاب العرب والعالميين.</p>

          <h3>المحاور: ما هي أهم التحديات التي واجهتك في مسيرتك الأدبية؟</h3>
          <p><strong>الضيف:</strong> التحديات كثيرة، منها صعوبة النشر في البداية، وإيجاد الجمهور المناسب، والتوازن بين الكتابة التجارية والكتابة الفنية. لكن الشغف والإصرار كانا المحرك الأساسي للاستمرار.</p>

          <h3>المحاور: كيف ترى مستقبل الأدب العربي في ظل التطورات التكنولوجية؟</h3>
          <p><strong>الضيف:</strong> أعتقد أن التكنولوجيا فتحت آفاقاً جديدة للأدب العربي. النشر الإلكتروني، ووسائل التواصل الاجتماعي، والمنصات الرقمية كلها وسائل تساعد الكتاب على الوصول لجمهور أوسع.</p>

          <h3>المحاور: ما نصيحتك للكتاب الشباب؟</h3>
          <p><strong>الضيف:</strong> نصيحتي هي القراءة المستمرة، والكتابة بانتظام، وعدم الخوف من النقد البناء. المهم هو الاستمرار والتطوير المستمر للأسلوب والمحتوى.</p>

          <h3>المحاور: هل لديك مشاريع قادمة تود أن تحدثنا عنها؟</h3>
          <p><strong>الضيف:</strong> نعم، أعمل حالياً على رواية جديدة تتناول قضايا معاصرة، وأيضاً أحضر لمجموعة شعرية جديدة. أتمنى أن تلقى إعجاب القراء.</p>
        </div>
      `,
      audioUrl: null,
      videoUrl: null
    };

    setInterview(sampleInterview);

    // حوارات مشابهة
    const related = Array.from({ length: 4 }, (_, index) => ({
      id: Math.floor(Math.random() * 100) + 1,
      title: `حوار مشابه ${index + 1}`,
      interviewee: `ضيف ${index + 1}`,
      type: ['مقابلة مكتوبة', 'مقابلة صوتية', 'مقابلة مرئية'][Math.floor(Math.random() * 3)],
      views: Math.floor(Math.random() * 500) + 50
    }));
    setRelatedInterviews(related);
  }, [id]);

  const handleLike = () => {
    setIsLiked(!isLiked);
    setInterview(prev => ({
      ...prev,
      likes: isLiked ? prev.likes - 1 : prev.likes + 1
    }));
  };

  const handleShare = () => {
    if (navigator.share) {
      navigator.share({
        title: interview.title,
        text: interview.summary,
        url: window.location.href
      });
    } else {
      navigator.clipboard.writeText(window.location.href);
      alert('تم نسخ الرابط');
    }
  };

  const getTypeIcon = (type) => {
    switch (type) {
      case 'مقابلة مكتوبة':
        return 'fas fa-file-alt';
      case 'مقابلة صوتية':
        return 'fas fa-microphone';
      case 'مقابلة مرئية':
        return 'fas fa-video';
      default:
        return 'fas fa-comments';
    }
  };

  if (!interview) {
    return (
      <div className="loading">
        <div className="container">
          <p>جاري تحميل تفاصيل الحوار...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="interview-details-page">
      <div className="container">
        <nav className="breadcrumb">
          <Link to="/">الرئيسية</Link>
          <span>/</span>
          <Link to="/interviews">الحوارات</Link>
          <span>/</span>
          <span>{interview.title}</span>
        </nav>

        <div className="interview-hero">
          <div className="hero-background">
            <div className="hero-pattern"></div>
            <div className="hero-gradient"></div>
          </div>
          <div className="hero-content">
            <div className="interview-meta">
              <div className="interview-type">
                <i className={getTypeIcon(interview.type)}></i>
                <span>{interview.type}</span>
              </div>
              <span className="interview-category">{interview.category}</span>
              <time className="interview-date">
                {interview.publishDate.toLocaleDateString('ar-EG')}
              </time>
            </div>
            
            <h1 className="interview-title">{interview.title}</h1>
            
            <div className="interview-participants">
              <div className="participant">
                <div className="participant-avatar">
                  <i className="fas fa-user"></i>
                </div>
                <div className="participant-info">
                  <span className="participant-label">الضيف</span>
                  <span className="participant-name">{interview.interviewee}</span>
                </div>
              </div>
              <div className="participant">
                <div className="participant-avatar interviewer">
                  <i className="fas fa-microphone"></i>
                </div>
                <div className="participant-info">
                  <span className="participant-label">المحاور</span>
                  <span className="participant-name">{interview.interviewer}</span>
                </div>
              </div>
            </div>

            <p className="interview-summary">{interview.summary}</p>

            <div className="interview-stats">
              <div className="stat-item">
                <i className="fas fa-eye"></i>
                <span className="stat-number">{interview.views}</span>
                <span className="stat-label">مشاهدة</span>
              </div>
              <div className="stat-item">
                <i className="fas fa-heart"></i>
                <span className="stat-number">{interview.likes}</span>
                <span className="stat-label">إعجاب</span>
              </div>
              <div className="stat-item">
                <i className="fas fa-clock"></i>
                <span className="stat-number">{interview.duration}</span>
                <span className="stat-label">دقيقة</span>
              </div>
            </div>

            <div className="interview-actions">
              <button 
                className={`action-btn primary ${isLiked ? 'liked' : ''}`}
                onClick={handleLike}
              >
                <i className="fas fa-heart"></i>
                {isLiked ? 'أعجبني' : 'إعجاب'}
              </button>
              <button className="action-btn" onClick={handleShare}>
                <i className="fas fa-share"></i>
                مشاركة
              </button>
            </div>
          </div>
        </div>

        <article className="interview-article">

          {interview.type === 'مقابلة صوتية' && interview.audioUrl && (
            <div className="media-player">
              <audio controls>
                <source src={interview.audioUrl} type="audio/mpeg" />
                متصفحك لا يدعم تشغيل الملفات الصوتية
              </audio>
            </div>
          )}

          {interview.type === 'مقابلة مرئية' && interview.videoUrl && (
            <div className="media-player">
              <video controls>
                <source src={interview.videoUrl} type="video/mp4" />
                متصفحك لا يدعم تشغيل الملفات المرئية
              </video>
            </div>
          )}

          <div className="interview-body">
            <div dangerouslySetInnerHTML={{ __html: interview.content }} />
          </div>

          <div className="interview-tags">
            <h3>الكلمات المفتاحية:</h3>
            <div className="tags-list">
              {interview.tags.map((tag, index) => (
                <span key={index} className="tag">{tag}</span>
              ))}
            </div>
          </div>

          {interview.intervieweeBio && (
            <div className="interviewee-bio">
              <h3>عن الضيف</h3>
              <p>{interview.intervieweeBio}</p>
            </div>
          )}
        </article>

        <div className="related-interviews">
          <h3>حوارات مشابهة</h3>
          <div className="related-interviews-grid">
            {relatedInterviews.map((relatedInterview) => (
              <div key={relatedInterview.id} className="related-interview-card">
                <div className="related-interview-icon">
                  <i className={getTypeIcon(relatedInterview.type)}></i>
                </div>
                <div className="related-interview-info">
                  <h4>{relatedInterview.title}</h4>
                  <p>مع: {relatedInterview.interviewee}</p>
                  <span className="type-badge">{relatedInterview.type}</span>
                  <div className="related-interview-footer">
                    <span className="views">{relatedInterview.views} مشاهدة</span>
                    <Link to={`/interviews/${relatedInterview.id}`} className="btn btn-small">
                      {relatedInterview.type === 'مقابلة مكتوبة' ? 'قراءة' : 
                       relatedInterview.type === 'مقابلة صوتية' ? 'استماع' : 'مشاهدة'}
                      <i className="fas fa-arrow-left"></i>
                    </Link>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default InterviewDetailsPage;
